document.addEventListener("DOMContentLoaded", function() {
    var variants_selector = document.querySelectorAll('[variant-option=couleur] input[type=radio]+label');
    variants_selector.forEach((item) => {
        item.addEventListener('click', function(event) {
            var new_url = item.getAttribute('data-gift-img');
            document.getElementById('giftcard-img').value = new_url;
        });
    });
});